import PaymentMethods from './PaymentMethods';

export { default as PaymentMethod } from './PaymentMethod';
export { default as CardDetails } from './components/CardDetails';
export default PaymentMethods;
